import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

//reducers
import languageReducer from "./language/languageReducer";
import burguerMenuReducer from "./burguerMenu/burguerMenuReducer";
import changeProjectReducer from "./changeProject/changeProjectReducer";
import captchaReducer from "./captcha/captchaReducer";
import whatsAppEmailReducer from "./whatsappEmail/whatsappEmailReducer";
import doneReducer from "./done/doneReducer";
import pressSubmitReducer from "./pressSubmit/pressSubmitReducer";
import screenReducer from "./screen/screenReducer";
import chatReducer from "./openChat/openChatReducer";
import refsReducer from "./refs/refsReducer";
import saveChatReducer from "./chatManager/chatManagerReducer";
import usersListReducer from "./userList/userListReducer";
import userChatIdReducer from "./userChatId/userChatIdReducer";



const persistConfig = {
    key: "root",
    storage: storage,
    whitelist:[ 'room', 'userChatId', 'userList'],
  };
  
  const rootReducer = combineReducers({
      language: languageReducer,
      burger: burguerMenuReducer,
      project: changeProjectReducer,
      captcha: captchaReducer,
      email: whatsAppEmailReducer,
      done: doneReducer,
      submit: pressSubmitReducer,
      screen: screenReducer,
      chat: chatReducer,
      ref: refsReducer,
      room: saveChatReducer,
      userList: usersListReducer,
      userChatId: userChatIdReducer
  });
  
  export default persistReducer(persistConfig, rootReducer);
  






